import BackgroundGeolocation, {
  Geofence
} from '@transistorsoft/capacitor-background-geolocation';
import {IONICWrapper } from '../utils/common';
import getURLDetails from './endPoints';
import { store } from '../store';
import { session } from '../actions/Login/action';
import { logEvent } from '../utils/Analytics';
import {
  KEYS,
  DB_GPS_ACTIVATED_SHIPMENT,
  MESSAGE_TYPE,
  SOUND_SRC,
  distanceFilter,
  GEO_ARRIVAL_RADIUS,
  STATIONARY_IDENTIFIER_INTERVAL,
  GEOFENCE_ACTION,
  GEOFENCE_IDENTIFIER,
  ENV,
  STATIONARY_IDENTIFIER_MAX_DISTANCE
} from '../utils/constants';
import { AuthSingleton } from '../utils/AuthSingleton';
import _, { cloneDeep } from 'lodash';
import { EVENT } from '../utils/constants.analytics';
import { checkLocationPermission, isAndroid11 } from '../utils/helper';

//Location REST API service URL
const locationURL = getURLDetails(
  'LOCATION_TRACKER',
  'LOCATION_TRACKER',
  null
).get_Service_Url();
//Azure Authentication vault data, i.f id_token, access_token, refresh_token
let vault = '';
// Shipment ID which is enabled for GPS tracking
let gpsTrackingShipmentID: any = null;

const sound = new Audio();

let _userId = '';
let _carrierId = '';
let _shipmentID = '';
let _sourceTMS = '';
let _activity = '';
let _carrierScac = '';

// All geofence for a Load. Geofence are push to activate Geofences array which will be active
// let geofences: Array<Geofence>;
// Stop sequence No
let sequenceNo = 1;

let stopId = '';
let locationId = '';

let loadDetailsTrackedShipment: any = null;

let timer: any;
let distance = 0;
let lastKnownLocationArrivalGeofence: any = null;

/**
 * Initialize the BackgroundGeolocation plugin Configuration
 * The Basic Configuration properlies are set.
 * Rest of the custom properlies will be set as per need basis
 * * @param
 * @returns null.
 */
export async function initiateGPSconfig() {
  const session: Session = new Session();

  // This handler fires whenever bgGeo receives a location update.
  BackgroundGeolocation.onLocation(
    location => {
    },
    error => {
    }
  );

  // This handler fires when movement states changes (stationary->moving; moving->stationary)
  BackgroundGeolocation.onMotionChange(location => {
  });

  // This event fires when a change in motion activity is detected
  BackgroundGeolocation.onActivityChange(activityEvent => {
  });

  // This event fires when the user toggles location-services authorization
  BackgroundGeolocation.onProviderChange(providerEvent => {
  });

  // Listen to #onSchedule events:
  BackgroundGeolocation.onSchedule(state => {
  });

  BackgroundGeolocation.onHttp(response => {
    console.log('[event] http: ', response);
    if (response.status === 200) {
      // Analytics implementation
      logEvent(EVENT.UE_GEO_TRACKING, {
        carrierId: _carrierId,
        shipmentId: _shipmentID
      });
    } else {
      let errorResponseText =
        response.responseText && response.responseText !== ''
          ? JSON.parse(response.responseText)
          : { message: '' };
      if (
        response.status === 401 ||
        errorResponseText.statusCode === 401 ||
        errorResponseText.message === 'Unauthorized'
      ) {
        session.getFreshToken().then(function(_token) {
          if (!isActiveSessionExpired(_token)) {
            vault = _token;
            BackgroundGeolocation.setConfig({
              headers: {
                'Ocp-Apim-Subscription-Key': KEYS.SUBSCRIPTION_KEY,
                Authorization: 'Bearer ' + vault
              }
            });
          }
        });
      }
    }
  });

  // Listen to geofence events
  BackgroundGeolocation.onGeofence(async geofence => {
    // Analytics implementation
    logEvent(EVENT.UE_GEOFENCE_ANNOUNCEMENT, {
      carrierId: geofence.location.extras!!.carrierId,
      shipmentId: geofence.location.extras!!.shipmentId,
      msgType: geofence.extras!!.messageType + GEOFENCE_ACTION.ENTER
    });

    if (geofence.extras) {
      if (geofence.identifier.includes(GEOFENCE_IDENTIFIER.PRE_ARRIVAL)) {
        if (geofence.action === GEOFENCE_ACTION.ENTER) {
          sound.src = SOUND_SRC.GEOFENCE_PRE_ARRIVAL_ENTRY;
        } else if (geofence.action === GEOFENCE_ACTION.EXIT) {
          sound.src = SOUND_SRC.GEOFENCE_PRE_ARRIVAL_EXIT;
          updateDepartureTime(geofence.extras.sequenceNo);
          clearArrivalGeofenceStationary();
        }
      } else if (geofence.identifier.includes(GEOFENCE_IDENTIFIER.ARRIVAL)) {
        if (geofence.action === GEOFENCE_ACTION.ENTER) {
          sound.src = SOUND_SRC.GEOFENCE_ARRIVAL_ENTRY;
          clearArrivalGeofenceStationary();
          lastKnownLocationArrivalGeofence = geofence.location;
          let count = 0;
          timer = setInterval(() => {
            count +=1;
            BackgroundGeolocation.getCurrentPosition(
              {
                timeout: 30, // 30 second timeout to fetch location
                maximumAge: 5000, // Accept the last-known-location if not older than 5000 ms.
                desiredAccuracy: 10, // Try to fetch a location with an accuracy of `10` meters.
                samples: 1, // How many location samples to attempt.});
                extras: {
                  // Custom meta-data.
                  messageType: MESSAGE_TYPE.GEO_TPOSITION,
                  activity: geofence.location.extras!!.activity,
                  shipmentId: geofence.location.extras!!.shipmentId,
                  carrierScac: geofence.location.extras!!.carrierScac,
                  userId: geofence.location.extras!!.userId,
                  sourceSystem: geofence.location.extras!!.sourceSystem,
                  carrierId: geofence.location.extras!!.carrierId,
                  stopId: geofence.extras!!.stopId,
                  sequenceNo: geofence.extras!!.sequenceNo,
                  locationId: geofence.extras!!.locationId
                }
              }).then((currentLocation) => {
                distance = getDistanceBetweenGeolocations(
                  lastKnownLocationArrivalGeofence.coords.latitude,
                  lastKnownLocationArrivalGeofence.coords.longitude,
                  currentLocation.coords.latitude,
                  currentLocation.coords.longitude,
                  'meters'
                );
                if (distance < STATIONARY_IDENTIFIER_MAX_DISTANCE && count > 2) {
                  BackgroundGeolocation.getCurrentPosition({
                    timeout: 30, // 30 second timeout to fetch location
                    maximumAge: 5000, // Accept the last-known-location if not older than 5000 ms.
                    desiredAccuracy: 10, // Try to fetch a location with an accuracy of `10` meters.
                    samples: 1, // How many location samples to attempt.});
                    extras: {
                      // Custom meta-data.
                      messageType: MESSAGE_TYPE.GEO_STOP_ARRIVAL,
                      activity: geofence.location.extras!!.activity,
                      shipmentId: geofence.location.extras!!.shipmentId,
                      carrierScac: geofence.location.extras!!.carrierScac,
                      userId: geofence.location.extras!!.userId,
                      sourceSystem: geofence.location.extras!!.sourceSystem,
                      carrierId: geofence.location.extras!!.carrierId,
                      stopId: geofence.extras!!.stopId,
                      sequenceNo: geofence.extras!!.sequenceNo,
                      locationId: geofence.extras!!.locationId
                    }
                  });
                  clearArrivalGeofenceStationary();
                  updateArrivalTime(geofence.extras!!.sequenceNo);
                } else {
                  lastKnownLocationArrivalGeofence = currentLocation;
                }
              },
              (error: any) => {
              }
            );
          }, STATIONARY_IDENTIFIER_INTERVAL);
        } else if (geofence.action === GEOFENCE_ACTION.EXIT) {
          sound.src = SOUND_SRC.GEOFENCE_ARRIVAL_EXIT;
          clearArrivalGeofenceStationary();
        }
      }
      if (KEYS.RELEASE === ENV.UNT) {
        sound.play();
      }
    }
  });

  const _shipment = IONICWrapper.details.vault && (await IONICWrapper.details.vault.getValue(DB_GPS_ACTIVATED_SHIPMENT));
  if (_shipment) {
    const shipmentObj = JSON.parse(_shipment);
    _activity = '';
    _shipmentID = shipmentObj.shipmentID;
    _carrierScac = shipmentObj.carrierScac;
    _userId = shipmentObj.userId;
    _sourceTMS = shipmentObj.sourceTMS;
    _carrierId = shipmentObj.carrierId;
    gpsTrackingShipmentID = shipmentObj.shipmentID;
  }

    // Geolocation Config
    BackgroundGeolocation.ready(
      {
        locationAuthorizationRequest: 'Always',
        desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_MEDIUM,
        distanceFilter: distanceFilter, //Approximately 800 meters
        disableElasticity: true,
        useSignificantChangesOnly: false, //set either useSignificantChangesOnly or distanceFilter; not both
        logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
        stopOnTerminate: false,
        startOnBoot: true,
        debug: false,
        backgroundPermissionRationale: {
          title: "Allow {applicationName} to access this device's location",
          message: "Location tracking is required so that we can automatically track the shipments, trigger workflow events on your behalf while the app is in use or backgrounded.",
          positiveAction: 'Change to "{backgroundPermissionOptionLabel}"',
          negativeAction: 'Cancel'
        },
        // locationUpdateInterval: 60000,  // Android only
        // fastestLocationUpdateInterval: 60000, // Android only
        //-----------------------
        //The Android plugin will ignore a received location when it is identical to the last location.
        //Set true to override this behaviour and record every location, regardless if it is identical
        //to the last location.
        allowIdenticalLocations: true, // Android only

        //-------Rest API config properties--------------------------
        autoSync: true,
        url: locationURL,
        headers: {
          'Ocp-Apim-Subscription-Key': KEYS.SUBSCRIPTION_KEY,
          //** */ this is the original flow for build
          Authorization: 'Bearer ' + vault
          //*
          //** */ this is the Testing flow for mimicking the unauthorized scenario
          //*
          // "Authorization": "Bearer " + __accessToken1
        },
        extras: {
          messageType: MESSAGE_TYPE.GEO_POSITION,
          activity: _activity,
          shipmentId: _shipmentID,
          carrierScac: _carrierScac,
          userId: _userId,
          sourceSystem: _sourceTMS,
          carrierId: _carrierId,
          stopId,
          sequenceNo,
          locationId
        }
      },
      state => {
        session.getFreshToken().then(function(_token) {
          if (_token) {
            vault = _token;
            BackgroundGeolocation.setConfig({
              headers: {
                'Ocp-Apim-Subscription-Key': KEYS.SUBSCRIPTION_KEY,
                Authorization: 'Bearer ' + vault
              }
            }).then(state => {
              console.log('[setConfig] success: ', state);
            });
          }
        });
      }
    );
}

/**
 *  Clear Arrival Geofence Stationary data and timer
 * * @param
 * @returns BackgroundGeolocation object.
 */
function clearArrivalGeofenceStationary() {
  distance = 0;
  lastKnownLocationArrivalGeofence = null;
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

/**
 *  BackgroundGeolocation Object will be returned to access as globally
 * * @param
 * @returns BackgroundGeolocation object.
 */
export function getGPSinstance() {
  return BackgroundGeolocation;
}

/**
 *  This method provides the current location latitude and longitude
 * * @param {*} get CurrentGPS callback to process the current location lat, long.
 * @returns null.
 */
export async function getCurrentPosition(getCurrentGPS: any) {
  // BackgroundGeolocation requestPermission called only for Android 11
  if(isAndroid11()){
    checkLocationPermission();
  }
  BackgroundGeolocation.getCurrentPosition(
    { persist: false }).then(
    (location: any) => {
      getCurrentGPS(location.coords.latitude, location.coords.longitude);
    },
    error => {
      // Error
    }
  );
}

/**
 *  This will start the GPS tracking as well as geofence tracking.
 * * @param shipmentDetails to strat the GPS tracking as well as geofence
 *  i.g. activity,shipmentId, carrierScac, userId, sourceSystem
 * @returns null.
 */
export function startGPStracking(shipmentDetails: any) {
  gpsTrackingShipmentID = shipmentDetails.shipmentID;
  validateLoadDetails(shipmentDetails.loadStops);

  if (loadDetailsTrackedShipment) {
    cogfigureActiveGeofence();
  }
  const session: Session = new Session();
  session.getFreshToken().then(function(_token) {
    if (_token) {
      vault = _token;
      BackgroundGeolocation.setConfig({
        distanceFilter: distanceFilter, //Approximately 800 meters
        disableElasticity: true,
        url: locationURL,
        headers: {
          'Ocp-Apim-Subscription-Key': KEYS.SUBSCRIPTION_KEY,
          Authorization: 'Bearer ' + vault
        },
        extras: {
          messageType: MESSAGE_TYPE.GEO_POSITION,
          activity: shipmentDetails.activity,
          shipmentId: shipmentDetails.shipmentID,
          carrierScac: shipmentDetails.carrierScac,
          userId: shipmentDetails.userId,
          sourceSystem: shipmentDetails.sourceTMS,
          carrierId: shipmentDetails.carrierId,
          stopId,
          sequenceNo,
          locationId
        }
      }).then(state => {
        // BackgroundGeolocation requestPermission called only for Android 11
        if(isAndroid11()){
          checkLocationPermission();
        }
        BackgroundGeolocation.start().then(() => {
          console.log('BackgroundGeolocation: started ', state);
        });
      });
    }
  });
}

function getGeofenceObjects(loadStops: any) {
  const getGeoFence = (loadStop: any, isPreArrivalFence: boolean) => ({
    identifier: isPreArrivalFence
      ? loadStop.stopId + '_' + GEOFENCE_IDENTIFIER.PRE_ARRIVAL
      : loadStop.stopId + '_' + GEOFENCE_IDENTIFIER.ARRIVAL,
    radius: isPreArrivalFence
      ? KEYS.GEO_PRE_ARRIVAL_RADIUS
      : GEO_ARRIVAL_RADIUS,
    latitude: loadStop.latitude,
    longitude: loadStop.longitude,
    notifyOnEntry: true,
    notifyOnExit: true,
    extras: {
      messageType: isPreArrivalFence
        ? MESSAGE_TYPE.GEOFENCE_PRE_ARRIVAL
        : MESSAGE_TYPE.GEOFENCE_ARRIVAL,
      stopId: loadStop.stopId,
      sequenceNo: loadStop.sequenceNo,
      locationId: loadStop.locationId
    }
  });

  const geofences: Array<Geofence> = [];
  loadStops.map((loadStop: any, index: any) => {
    if (loadStop.sequenceNo === sequenceNo) {
      const preArrivalFrnce = getGeoFence(loadStop, true);
      geofences.push(preArrivalFrnce);
      const arrivalFrnce = getGeoFence(loadStop, false);
      geofences.push(arrivalFrnce);
    }
  });
  return geofences;
}

function updateArrivalTime(currentSequenceNo: any) {
  for (let i = 0; i < loadDetailsTrackedShipment.length; i++) {
    if (loadDetailsTrackedShipment[i].sequenceNo === currentSequenceNo) {
      loadDetailsTrackedShipment[
        i
      ].actualArrivalDateTime = new Date().toISOString();
    }
  }
}

function updateDepartureTime(currentSequenceNo: any) {
  let isLastStop = false;
  for (let i = 0; i < loadDetailsTrackedShipment.length; i++) {
    if (loadDetailsTrackedShipment[i].sequenceNo === currentSequenceNo) {
      if (loadDetailsTrackedShipment[i].actualArrivalDateTime) {
        loadDetailsTrackedShipment[
          i
        ].actualDepartureDateTime = new Date().toISOString();
        if (
          loadDetailsTrackedShipment[i].stopType === 'D' &&
          loadDetailsTrackedShipment.length === currentSequenceNo
        ) {
          isLastStop = true;
          BackgroundGeolocation.stop().then(()=>{
            console.log('BackgroundGeolocation: stopped ');
          });;
          IONICWrapper.details.vault && (IONICWrapper.details.vault.storeValue(DB_GPS_ACTIVATED_SHIPMENT,""));
          BackgroundGeolocation.removeGeofences(); //Destroy all [[Geofence]].
        }
      }
    }
  }
  if (!isLastStop) {
    cogfigureActiveGeofence();
  }
}

async function cogfigureActiveGeofence() {
  // Only 1 pair of geo-fences to be active at any point of time.
  // Once current Stop will be departed, next Stop geofence pair will be activated
  // Remove Geofences before add new Geofences
  const updatedsequenceNo = updateActiveGeofenceSequenceNo();

  let currentSequenceNo;
  const geofences = await BackgroundGeolocation.getGeofences();
  geofences.forEach((geofence: any, index: any) => {
    currentSequenceNo = geofence.extras.sequenceNo;
  });
  if (currentSequenceNo !== updatedsequenceNo) {
    // this check to avoid multiple execution for same load in componentDidUpdate

    // Before Configure the Geofence Clean the Arrival Geofence Stationary timer and data
    clearArrivalGeofenceStationary();

    sequenceNo = updatedsequenceNo;
    BackgroundGeolocation.removeGeofences();
    const activeGeofences = getGeofenceObjects(loadDetailsTrackedShipment);
    // Add a geofences.
    if (activeGeofences.length > 0) {
      // Geofences will be added when activeGeofences has data
      BackgroundGeolocation.addGeofences(
        activeGeofences,
        (success: any) => {
        },
        (error: any) => {
          //Error
        }
      );
    }
  } else {
    for (let index = 0; index < loadDetailsTrackedShipment.length; index++) {
      if (
        loadDetailsTrackedShipment[index].sequenceNo === currentSequenceNo &&
        loadDetailsTrackedShipment[index].actualArrivalDateTime
      ) {
        // Before Configure the Geofence Clean the Arrival Geofence Stationary timer and data
        clearArrivalGeofenceStationary();
      }
    }
  }
}

/**
 *  This will update the active Geofence sequenceNo
 * * @param
 * @returns null.
 */
function updateActiveGeofenceSequenceNo() {
  let stopSequenceNo = 99;
  for (let i = 0; i < loadDetailsTrackedShipment.length; i++) {
    if (
      !loadDetailsTrackedShipment[i].actualArrivalDateTime ||
      !loadDetailsTrackedShipment[i].actualDepartureDateTime
    ) {
      if (stopSequenceNo > loadDetailsTrackedShipment[i].sequenceNo) {
        stopSequenceNo = loadDetailsTrackedShipment[i].sequenceNo;
        stopId = loadDetailsTrackedShipment[i].stopId;
        locationId = loadDetailsTrackedShipment[i].locationId;
      }
    }
  }
  return stopSequenceNo;
}

/**
 *  This will send pings for Geo Start Trip Location
 * * @param shipmentDetails to send the Geo Start Trip Location
 *  i.g. activity,shipmentId, carrierScac, userId, sourceSystem
 * @returns null.
 */
export function sendGeoStartTripLocation(shipmentDetails: any) {
  BackgroundGeolocation.getCurrentPosition({
    timeout: 30, // 30 second timeout to fetch location
    maximumAge: 5000, // Accept the last-known-location if not older than 5000 ms.
    desiredAccuracy: 10, // Try to fetch a location with an accuracy of `10` meters.
    samples: 1, // How many location samples to attempt.});
    extras: {
      // Custom meta-data.
      messageType: MESSAGE_TYPE.GEO_START_TRIP_LOCATION,
      activity: shipmentDetails.activity,
      shipmentId: shipmentDetails.shipmentID,
      carrierScac: shipmentDetails.carrierScac,
      userId: shipmentDetails.userId,
      sourceSystem: shipmentDetails.sourceTMS,
      carrierId: shipmentDetails.carrierId,
      stopId,
      sequenceNo,
      locationId
    }
  });
}

/**
 *  This will provide the GPS tracking enabled Shipment ID
 * * @param
 * @returns gpsTrackingShipmentID.
 */
export async function getGPStrackingShipmentID() {
  const state = await BackgroundGeolocation.getState();
  if(state && state.enabled && state.extras) {
    return state.extras!.shipmentId;
  }
}

/**
 *  This will set the GPS tracking enabled Shipment ID
 * * @param gpsTrackingShipmentID
 * @returns null.
 */
export function setGPStrackingShipmentID(shipmentID: any) {
  gpsTrackingShipmentID = shipmentID;
}

/**
 *  This will provide the GPS tracking enabled Shipment ID
 * * @param
 * @returns gpsTrackingShipmentID.
 */
export function getGeofenceSequenceNo() {
  return sequenceNo;
}

/**
 *  This will provide the loadDetailsTrackedShipment object
 * * @param
 * @returns loadDetailsTrackedShipment.
 */
export function getLoadDetailsTrackedShipment() {
  return loadDetailsTrackedShipment;
}

/**
 *  This will set the GPS tracking enabled Shipment ID
 * * @param gpsTrackingShipmentID
 * @returns null.
 */
export function setGeofenceSequenceNo(_updatedSequenceNo: any) {
  if (_updatedSequenceNo > sequenceNo) {
    sequenceNo = _updatedSequenceNo;
  }
}

/**
 *  This will set the refreshed loadDetails object
 * * @param loadDetailsRefreshedShipment
 * @returns null.
 */
export function setLoadDetailsTrackedShipment(
  loadDetailsRefreshedShipment: any
) {
  const loadDetailsRefreshedShipmentObj = cloneDeep(
    loadDetailsRefreshedShipment
  );
  validateLoadDetails(loadDetailsRefreshedShipmentObj);
}

/**
 * Validation for any data change is happened for refreshed loadDetails object or not
 * * @param loadStops
 * @returns null.
 */
function validateLoadDetails(loadStops: any) {
  if (!_.isEqual(loadStops, loadDetailsTrackedShipment)) {
    if (loadStops.length > 0 && loadStops[0].stopId) {
      loadDetailsTrackedShipment = loadStops;
      if (loadDetailsTrackedShipment) {
        cogfigureActiveGeofence();
      }
    }
  }
}

/**
 * This routine calculates the distance between two points (given the
 * latitude/longitude of those points). It is being used to calculate
 * the distance between two locations using GeoDataSource (TM) prodducts
 *
 *  Definitions:
 * South latitudes are negative, east longitudes are positive
 * Passed to function:
 * lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)
 * unit = the unit you desire for results
 * where: 'M' is statute miles (default)
 * 'meters' is meters
 * * @param lat1, lon1, lat2, lon2, unit
 * @returns distance
 */
function getDistanceBetweenGeolocations(
  lat1: any,
  lon1: any,
  lat2: any,
  lon2: any,
  unit: any
) {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  } else {
    const radlat1 = (Math.PI * lat1) / 180;
    const radlat2 = (Math.PI * lat2) / 180;
    const theta = lon1 - lon2;
    const radtheta = (Math.PI * theta) / 180;
    let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === 'meters') {
      dist = dist * 1.609344 * 1000;
    }
    return dist;
  }
}

function isActiveSessionExpired(token: any) {
  // console.log("token::::", token);
  if (!token) {
    // console.log("Token is expired");
    BackgroundGeolocation.stop().then(() => { // Stop the GPS tracking and Disable location and geofence monitoring.
      // console.log("Stop the GPS tracking and Disable location and geofence monitoring.");
      BackgroundGeolocation.removeGeofences(); //Destroy all [[Geofence]].
      IONICWrapper.details.vault && (IONICWrapper.details.vault.removeValue(DB_GPS_ACTIVATED_SHIPMENT)); // Remove all the records from local DB
    });
    return true;
  }
  return false;
}

/**
 *  This Session class object will generate the refresh token, once it will be expired.
 * *
 */
class Session {
  __token: any;
  async getFreshToken() {
    const auth = AuthSingleton.getInstance();
    const isActiveSession = auth && await auth.isAuthenticated();
    if (!isActiveSession) {
        store.dispatch(session(Math.floor(Math.random() * 100)));
        return null;
    }
    this.__token = (await auth.getAuthResponse()).id_token;
    return this.__token;
  }
}
